import { AuthRoutes } from "./auth-routes";
import {
  AneelTariffRoutes,
  DashboardRoutes,
  HelpRoutes,
  KnowledgeBaseRoutes,
  LeadRoutes,
  LogsAuditRoutes,
  ManagerRoutes,
  ReleaseNoteRoutes,
  UsersRoutes,
} from "./main-routes";

export type Routes = typeof ROUTES;

export const ROUTES = {
  AUTH: AuthRoutes,
  DASHBOARD: DashboardRoutes,
  LOGS: LogsAuditRoutes,
  MANAGER: ManagerRoutes,
  USERS: UsersRoutes,
  ANEEL_TARIFFS: AneelTariffRoutes,
  HELP: HelpRoutes,
  KNOWLEDGE_BASE: KnowledgeBaseRoutes,
  RELEASE_NOTES: ReleaseNoteRoutes,
  LEADS: LeadRoutes,
} as const;
